import { Flex, FlexProps } from '@chakra-ui/react'
import { motion } from 'framer-motion'

const MotionFlex = motion<FlexProps>(Flex)

export default MotionFlex
